module.exports = __webpack_public_path__ + "media/images/profile-62b510141fd902006663e05aeb60a920.png";